app.PublicDistrictPage = (
    function () {
        var publicDistrictPage = {
            //Index Page
            Index: function () {
                this.BindContentEditor(document);
                app.SavedVacancies.Init();
                $(document).ready(function () {
                    app.page.components["PublicDistrictPageVacanciesGrid"][0].refreshGrid();
                    app.VacancyList.SetStaffTypeDropDowns();
                    app.VacancyList.BindStaffTypeDropdownFunctionality();
                });
            },
            BindContentEditor: function (el) {
                $("#btnEditPage", $(el)).on("click", function () {
                    $.ajax({
                        url: "/District/EditContent/" + $("#btnEditPage").data("districtid"),
                        context: this, error: app.Page.handleAjaxError
                    }).done(function (data) {
                        $("#districtContentModal #districtContentForm").html(data);
                        $("#districtContentModal").modal("show");
                        app.input.initTextEditor($("#districtContentModal"));
                        $('[data-toggle="tooltip"]').tooltip({ html: true });
                    });
                });
            }
        };
        return publicDistrictPage;
    }()
);